import * as BaseUrl from './BaseUrl.js'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './App'
import { Provider, IReactComponent } from 'mobx-react'
import { Router, Route } from 'react-router-dom'

import './index.css'
import { createStore } from './store'

import createBrowserHistory from 'history/createBrowserHistory'
import { syncHistoryWithStore } from 'mobx-react-router'
import { createHashHistory } from 'history'

console.log('Baseurl:', BaseUrl.BaseUrl)

// import registerServiceWorker from './registerServiceWorker';
function renderApp (component: IReactComponent) {
  const store = createStore()

  // @ts-ignore
  window.store = store

  const browserHistory = window.hasOwnProperty('cordova') ? createHashHistory() : createBrowserHistory()
  const history = syncHistoryWithStore(browserHistory, store.storeRouter)

  history.subscribe(() => {
    store.storeCommon.menu.open = false
    if (window.gtag) {
      window.gtag('config', 'UA-130101283-1', { 'page_path': store.storeRouter.location.pathname, 'anonymize_ip': true })
    }
  })

  // setTimeout(() => {
  //   // redirect if ie
  //   if (isIE()) {
  //     console.log('Found IE')
  //     if (store.storeRouter.location.pathname !== '/browser-not-supported') {
  //       store.storeRouter.push('/browser-not-supported')
  //     }
  //   }
  // }, 50)

  ReactDOM.render(
    <Provider {...store} >
      <Router history={history}>
       <Route component={App} props/>
      </Router>
    </Provider>,
    document.getElementById('root') as HTMLElement)

}
renderApp(App)

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx